import { type Trello } from "../types/trello"
import { getTimerState } from "../storage"

export async function getCardBadges(t: Trello.PowerUp.IFrame) {
  const [timerStartedAt, timerCardId] = await getTimerState(t)
  const currentCardId = t.getContext().card

  if (!timerStartedAt || timerCardId !== currentCardId) {
    return []
  }

  return [{
    dynamic: async () => {
      const [startedAt] = await getTimerState(t)
      if (!startedAt) return null

      const elapsedMinutes = Math.floor((Date.now() - new Date(startedAt).getTime()) / 60000)
      return {
        text: `⏱ ${elapsedMinutes}m - timer is running`,
        color: "red" as const,
        refresh: 30,
      }
    }
  }]
}
